import type { FC } from 'react'
import type { Vehicle } from '../../types/vehicle.types'
import './styles.css'

type VehicleHeaderProps = {
  vehicle?: Vehicle
  onChangeVehicle?: () => void
}

export const VehicleHeader: FC<VehicleHeaderProps> = ({ vehicle, onChangeVehicle }) => {
  if (!vehicle) {
    return null
  }

  return (
    <div className="vehicle-header-root">
      <div className="vehicle-header-wrapper">
        <div className="vehicle-header-info">
          <div className="vehicle-header-model">{vehicle.modelName}</div>
          <div className="vehicle-header-vin">{vehicle.vin}</div>
          {vehicle.consentId ? (
            <div className="vehicle-header-consent-id">{vehicle.consentId}</div>
          ) : null}
          <div className="vehicle-header-deregister">
            <button type="button" className="vehicle-header-link-button" onClick={onChangeVehicle}>
              Change Vehicle
            </button>
          </div>
        </div>
        <div className="vehicle-header-image-wrapper">
          {vehicle.imageUrl ? (
            <img src={vehicle.imageUrl} alt={vehicle.modelName} />
          ) : (
            <div>No image</div>
          )}
        </div>
      </div>
    </div>
  )
}
